import type { ReactElement } from 'react';
import { EntityContext } from 'components/scenes';
import type { ActivityType } from 'types';
import { ProductActions } from './ProductActions';
import { drawerEntityContext } from './entityContext';

export type ProductDrawerActionsProps<TProduct> = {
  product: TProduct;
  type: ActivityType;
  endpoint: string;
  onClose: () => void;
  onChanged: () => void;
  /** Entity-local refresh used by catalogue dialogs; defaults to collection reconciliation. */
  mutate?: () => unknown;
  onCopy?: () => void;
  onMoved?: () => void;
};

/** Shared catalogue/copy action footer for Product drawers. */
export function ProductDrawerActions<TProduct>({
  product,
  type,
  endpoint,
  onClose,
  onChanged,
  mutate = onChanged,
  onCopy,
  onMoved,
}: ProductDrawerActionsProps<TProduct>): ReactElement {
  return (
    <EntityContext.Provider value={drawerEntityContext(product, endpoint, mutate)}>
      <ProductActions
        type={type}
        onClose={onClose}
        onChanged={onChanged}
        onCopy={onCopy}
        onMoved={onMoved}
        inDialogFooter
      />
    </EntityContext.Provider>
  );
}
